"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AffiliateNetwork = void 0;
var AffiliateNetwork;
(function (AffiliateNetwork) {
    AffiliateNetwork["Amazon"] = "Amazon";
    AffiliateNetwork["Rakuten"] = "Rakuten";
    AffiliateNetwork["PubAdHub"] = "PubAdHub";
})(AffiliateNetwork || (exports.AffiliateNetwork = AffiliateNetwork = {}));
